import ComponentBase from '../base/component-base';

/**
 * Hero Component
 * Handles fade slideshow for hero images
 */
class Hero extends ComponentBase {
  private imagesContainer: HTMLElement | null = null;
  private imageElements: HTMLElement[] = [];
  private currentIndex: number = 0;
  private intervalId: number | null = null;
  private transitionDuration: number = 1000; // 1 second fade
  private displayDuration: number = 5000; // 5 seconds display

  constructor(element: HTMLElement) {
    super(element);

    console.log('[Hero] Initializing hero:', element);

    this.init();
  }

  protected init(): void {
    // Find images container and image elements
    this.imagesContainer = this.element.querySelector('.js-hero-images');
    const images = this.element.querySelectorAll<HTMLElement>('.js-hero-image');

    if (!this.imagesContainer || images.length === 0) {
      console.warn('[Hero] Required elements not found');
      return;
    }

    this.imageElements = Array.from(images);

    console.log('[Hero] Found', this.imageElements.length, 'images');

    // Set background color to prevent blend mode transparency
    this.imagesContainer.style.backgroundColor = '#000';

    // Add transition to images
    this.imageElements.forEach((image) => {
      image.style.transition = `opacity ${this.transitionDuration}ms ease-in-out`;
    });

    // Add is-zoomin to first image (which already has is-active)
    if (this.imageElements[0]) {
      this.imageElements[0].classList.add('is-zoomin');
    }

    // Start slideshow
    this.startSlideshow();

    console.log('[Hero] Slideshow started');
  }

  private startSlideshow(): void {
    // Clear any existing interval
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }

    // Start interval for automatic transition
    this.intervalId = window.setInterval(() => {
      this.nextSlide();
    }, this.displayDuration);
  }

  private nextSlide(): void {
    // Calculate next index
    const nextIndex = (this.currentIndex + 1) % this.imageElements.length;

    console.log('[Hero] Transitioning from', this.currentIndex, 'to', nextIndex);

    const currentImage = this.imageElements[this.currentIndex];
    const nextImage = this.imageElements[nextIndex];

    // Remove active class from current image (start fade out)
    currentImage.classList.remove('is-active');

    // Add active and zoomin classes to next image (start fade in and zoom)
    nextImage.classList.add('is-active', 'is-zoomin');

    // Remove zoomin from previous image after transition completes
    setTimeout(() => {
      currentImage.classList.remove('is-zoomin');
    }, this.transitionDuration);

    // Update current index
    this.currentIndex = nextIndex;
  }

  private stopSlideshow(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  protected onDestroy(): void {
    super.onDestroy();

    this.stopSlideshow();
  }
}

export default Hero;
